import { DistributionType, ProjectType } from '@aviv-search/types';
// French Ad oriented enum: Transaction Type was the legacy distribution type
export var TransactionType;
(function (TransactionType) {
    TransactionType[TransactionType["RENT"] = 1] = "RENT";
    TransactionType[TransactionType["BUY"] = 2] = "BUY";
    TransactionType[TransactionType["TEMPORARY_RENT"] = 3] = "TEMPORARY_RENT";
    // N/A -> 4: Location de vacances
    TransactionType[TransactionType["LIFE_ANNUITY"] = 5] = "LIFE_ANNUITY";
    TransactionType[TransactionType["INVESTMENT"] = 6] = "INVESTMENT";
    TransactionType[TransactionType["UNKNOWN"] = 7] = "UNKNOWN";
    // N/A -> 8: Vente de Prestige
    TransactionType[TransactionType["NEW"] = 9] = "NEW";
    // N/A -> 10: Vente de Fonds de Commerce
    // N/A -> 11: Cession de Bail
})(TransactionType || (TransactionType = {}));
export const getTransactionType = (searchModel) => {
    if (!searchModel?.distributionTypes)
        return TransactionType.UNKNOWN;
    const { distributionTypes, projectTypes = [] } = searchModel;
    // rent
    if (distributionTypes?.includes(DistributionType.RENT) ?? false) {
        return projectTypes.includes(ProjectType.SHORT_TIME_RENTAL) ? TransactionType.TEMPORARY_RENT : TransactionType.RENT;
    }
    // Not existing yet
    //   if (projectTypes.includes(ProjectType.LIFE_ANNUITY))
    //     return TransactionType.Achat_Viager
    if (projectTypes.includes(ProjectType.INVESTMENT))
        return TransactionType.INVESTMENT;
    if (projectTypes.includes(ProjectType.NEW_BUILD))
        return TransactionType.NEW;
    // default
    return TransactionType.BUY;
};
